import { render } from "./property-summary-title.vue?vue&type=template&id=23418b92"
import script from "./property-summary-title.js?vue&type=script&lang=js"
export * from "./property-summary-title.js?vue&type=script&lang=js"

import "./property-summary-title.vue?vue&type=style&index=0&id=23418b92&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__